var _defs, _rect, _rect2, _rect3, _rect4, _circle, _circle2, _rect5, _rect6, _line, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatternTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-5 -5.1 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlLang: "en",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clock-face-clip"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 4
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    rx: 0.2,
    x: -1,
    y: -5.9,
    fill: "#EBCC40",
    transform: "rotate(-40)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.6,
    height: 1,
    rx: 0.2,
    x: -1.3,
    y: -5.4,
    fill: "#010C21",
    transform: "rotate(-40)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    rx: 0.2,
    x: -1,
    y: -5.9,
    fill: "#EBCC40",
    transform: "rotate(40)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.6,
    height: 1,
    rx: 0.2,
    x: -1.3,
    y: -5.4,
    fill: "#010C21",
    transform: "rotate(40)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 4.7,
    fill: "#010C21"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    fill: "#36599D",
    clipPath: "url(#clock-face-clip)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    fill: "#EBCC40",
    clipPath: "url(#clock-face-clip)",
    transform: "rotate(90)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    fill: "#74329D",
    clipPath: "url(#clock-face-clip)",
    transform: "rotate(-210)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 3,
    stroke: "#010C21",
    strokeWidth: 1,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: 230,
    to: 590,
    dur: "5s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 1,
    fill: "#010C21"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternTimer);
export default __webpack_public_path__ + "static/media/pattern-timer.8f21b6e10334e8c4ad92b50e28d0d1bb.svg";
export { ForwardRef as ReactComponent };